import classNames from 'classnames';
import { ComponentProps } from 'react';

import Text from '../Text/Text';

import styles from './Badge.module.css';

export type BadgeLevel =
    | 'default'
    | 'dimmed'
    | 'success'
    | 'warning'
    | 'error'
    | 'transparent-white';

type BadgeProps = {
    variant?: BadgeLevel;
} & Omit<ComponentProps<typeof Text>, 'className' | 'lineHeight'>;

const Badge = ({
    variant = 'default',
    size = 'small',
    ...textProps
}: BadgeProps) => {
    const classes = classNames(styles.Root, {
        [styles.variantDefault]: variant === 'default',
        [styles.variantSubtle]: variant === 'dimmed',
        [styles.variantSuccess]: variant === 'success',
        [styles.variantWarning]: variant === 'warning',
        [styles.variantError]: variant === 'error',
        [styles.variantTransparentWhite]: variant === 'transparent-white',
    });

    return (
        <Text
            className={classes}
            size={size}
            lineHeight="small"
            {...textProps}
        />
    );
};

export default Badge;
